/*
 * Ryan O'Dowd
 * 2025-05-26
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  useState,
} from 'react';

export default function useSelectVerses(defaultState) {
  const [_selectedVerseNums, setSelectedVerseNums] = useState(defaultState);

  const minSelectedVerseNum = Math.min(..._selectedVerseNums);
  const maxSelectedVerseNum = Math.max(..._selectedVerseNums);

  const onVersePress = (verse) => {
    const verseNum = +verse.verseApiId.split('.').pop();

    if (_selectedVerseNums.includes(verseNum)) {
      if (![verseNum, verse.rangeStartVerseNumber, verse.rangeEndVerseNumber].some((vn) => [minSelectedVerseNum, maxSelectedVerseNum].includes(vn))) {
        return;
      }
      const verseNumsToUnselect = [verseNum];
      if (verse.rangeStartVerseNumber && verse.rangeEndVerseNumber) {
        for (let vn = verse.rangeStartVerseNumber; vn <= verse.rangeEndVerseNumber; vn++) {
          if (_selectedVerseNums.includes(vn)) {
            verseNumsToUnselect.push(vn);
          }
        }
      }
      setSelectedVerseNums((curr) => curr.filter((vn) => !verseNumsToUnselect.includes(vn)));
    } else {
      const newVerseNums = [verseNum];
      if (verse.rangeStartVerseNumber && verse.rangeEndVerseNumber) {
        for (let vn = verse.rangeStartVerseNumber; vn <= verse.rangeEndVerseNumber; vn++) {
          newVerseNums.push(vn);
        }
      }
      if (_selectedVerseNums.length) {
        if (verseNum > maxSelectedVerseNum) {
          for (let vn = maxSelectedVerseNum; vn <= verseNum; vn++) {
            newVerseNums.push(vn);
          }
        } else {
          for (let vn = verseNum; vn <= minSelectedVerseNum; vn++) {
            newVerseNums.push(vn);
          }
        }
      }
      setSelectedVerseNums((curr) => [...new Set([...curr, ...newVerseNums])].sort((a, b) => a - b));
    }
  };

  return [
    _selectedVerseNums,
    onVersePress,
    () => setSelectedVerseNums([]),
    (totalNumVerses) => setSelectedVerseNums([...Array(totalNumVerses)].map((__, index) => index + 1)), // @TODO: is this used?
  ];
}
